import moment from 'moment';

/** Format the search state stores dates in. */
const SEARCH_DATE_FORMAT = 'DD-MM-YYYY';
/** Format the carousel session and the backend Mixpanel series both use. */
const ISO_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Normalizes a search-state date to the format the attribution series uses.
 * Parsed strictly: the carousel stores `YYYY-MM-DD` while the search state stores `DD-MM-YYYY`,
 * and emitting both shapes under one property is indistinguishable from good data in Mixpanel.
 * @param {string} date - A date as held in the search state.
 * @returns {string|undefined} The date as `YYYY-MM-DD`, or undefined when absent or unparseable.
 */
export function normalizeSearchDate(date) {
  if (!date) return undefined;

  const parsed = moment(date, SEARCH_DATE_FORMAT, true);

  return parsed.isValid() ? parsed.format(ISO_DATE_FORMAT) : undefined;
}

/**
 * Whether the chosen trip departs on a different calendar day than the one originally searched.
 *
 * Compares wall-clock calendar dates, never instants: the API sends trip times as offsetless ISO
 * strings in the origin city's own zone, and the funnel has no `moment-timezone`, so parsing them
 * into instants would reinterpret them in the browser's zone and shift the answer by a day for the
 * night departures this metric exists to measure.
 * @param {string} tripDeparture - The chosen trip's departure, as an ISO-like string.
 * @param {string} searchOriginalDate - The originally searched date, as `YYYY-MM-DD`.
 * @returns {boolean|undefined} The comparison, or undefined when either side is missing.
 */
export function getNextDayResult(tripDeparture, searchOriginalDate) {
  if (!tripDeparture || !searchOriginalDate) return undefined;

  return String(tripDeparture).slice(0, ISO_DATE_FORMAT.length) !== searchOriginalDate;
}
